import { STATIC_URL } from 'constants/data'

import styles from './course-uniq-points.module.scss'

type IData = {
  icon: {
    src: string
    alt: string
    width: number
    height: number
  }
  title?: string
  text: JSX.Element | string
}

const imgCommonProps = {
  alt: 'Icon',
  width: 50,
  height: 50,
}

const dataCardioUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_icon_1.svg` },
    title: 'От основоположников клиник сердечной недостаточности в России: ',
    text: 'как создать и организовать работу клиники сердечной недостаточности от нормативных документов до мониторинга пациента в реальной клинической практике',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_icon_2.svg` },
    title: 'Расскажем',
    text: 'как говорить с пациентом о факторах риска сердечно-сосудистых заболеваний, правильном питании и образе жизни максимально понятно и эффективно',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_icon_3.svg` },
    title: 'Объясним',
    text: 'тактику действий при острых неотложных состояниях в кардиологии и аритмологии',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_icon_4.svg` },
    title: 'Практикующие кардиохирурги',
    text: 'расскажут о современных возможностях лечения фибрилляции предсердий и ЧКВ',
  },
]

const dataOsteoporosisUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_osteo_1.svg` },
    title: 'Остеопороз',
    text: 'является причиной большего числа дней, проведенных в больнице, чем рак молочной железы, стенокардия, диабет и другие заболевания',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_osteo_2.svg` },
    title: 'Каждые 3 секунды',
    text: 'происходит 1 новый перелом',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_osteo_3.svg` },
    title: '9 миллионов',
    text: 'переломов происходят ежегодно',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/uniq_osteo_4.svg` },
    title: 'На 86%',
    text: 'предшествующий перелом повышает риск любого последующего перелома',
  },
]

const dataSomnologyUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/somnology-course/uniq_somno_1.png` },
    title: `Знания о физиологии <br>расстройствах сна`,
    text: 'не только в молодом возрасте, но и в пожилом и старческом возрасте, среди которого нарушение сна наиболее распространено',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/somnology-course/uniq_somno_2.png` },
    title: 'Знания и практические рекомендации по рациональной фармакотерапии',
    text: 'основных расстройств сна, по лекарственно-индуцированным расстройствам сна',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/somnology-course/uniq_somno_3.png` },
    title: 'Алгоритмы выбора',
    text: 'медикаментозной и немедикаментозной терапии нарушений сна и рекомендации по профилактике нарушений',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/somnology-course/uniq_somno_4.png` },
    title: 'Современные методы исследования',
    text: 'инструментальные, нейропсихологические и лабораторные в области нарушений сна',
  },
]

const dataGktUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/gkt_uniq_icon_1.svg` },
    title: '',
    text: (
      <>
        Как гастропатология может повлиять на{' '}
        <span className={styles.semibold}>работу всех систем органов</span>
      </>
    ),
    unoptimized: true,
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/gkt_uniq_icon_2.svg` },
    title: '',
    text: (
      <>
        Почему последние данные говорят о{' '}
        <span className={styles.semibold}>критической важности микробиоты</span>
      </>
    ),
    unoptimized: true,
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/gkt_uniq_icon_3.svg` },
    title: '',
    text: (
      <>
        Какие <span className={styles.semibold}>параметры фармакодинамики и фармакокинетики</span>{' '}
        различных лекарственных препаратов могут изменить ход терапии
      </>
    ),
    unoptimized: true,
  },
]

const dataGeriatryBasicUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/geriatrics-basic/uniq_icon_1.png` },
    title: 'Включает в себя самые распространенные заболевания и патологии в пожилом возрасте:',
    text: 'артериальная гипертензия, остеоартрит и урологические заболевания',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/geriatrics-basic/uniq_icon_2.png` },
    title: 'Содержит способы и методы применения медикаментов',
    text: 'с целью профилактики, лечения или уменьшения симптоматики этих заболеваний, чтобы врач любой специальности мог ориентироваться в симптомах и методах лечения',
  },
]

const dataMiniCardioUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/mini-cardio_icon_1.svg` },
    text: (
      <>
        <span className={styles.semibold}>
          Актуальная информация о принципах диагностики и лечения
        </span>{' '}
        сердечно-сосудистых заболеваний — ишемической болезни сердца, ХСН, фибрилляции предсердий
      </>
    ),
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/mini-cardio_icon_2.svg` },
    text: (
      <>
        Прохождение данного курса полезно не только кардиологам,{' '}
        <span className={styles.semibold}>но и врачам других специальностей — </span>
        терапевтам, врачам общей практики и другим специалистам, которые могут вести коморбидных
        пациентов
      </>
    ),
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/mini-cardio_icon_3.svg` },
    text: (
      <>
        Программа курса фокусируется на важных вопросах{' '}
        <span className={styles.semibold}>
          диагностического поиска, оценки рисков и назначения адекватного лечения
        </span>{' '}
        согласно клиническим данным
      </>
    ),
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/mini-cardio_icon_4.svg` },
    text: (
      <>
        Информация{' '}
        <span className={styles.semibold}>
          обладает практической направленностью и применима в условиях реальной практики
        </span>{' '}
        врачей амбулаторного и стационарного звена здравоохранения
      </>
    ),
  },
]

const dataModernMethodsDmpUniq = [
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/modern-methods-dmp/uniq_icon_1.svg` },
    title: 'Практическая направленность',
    text: 'Курс разработан ведущими специалистами с учетом реальных клинических случаев и ориентирован на применение полученных знаний в повседневной практике',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/modern-methods-dmp/uniq_icon_2.svg` },
    title: 'Интерактивные методики обучения',
    text: 'Участники смогут обучаться через интерактивные вебинары, использование медицинских гаджетов и симуляцию клинических ситуаций, что способствует лучшему усвоению материала',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/modern-methods-dmp/uniq_icon_3.svg` },
    title: 'Инновационные технологии',
    text: 'Курс включает новейшие достижения в области дистанционного мониторинга и использования медицинских устройств, обеспечивая врачам доступ к передовым методам диагностики и лечения',
  },
  {
    icon: { ...imgCommonProps, src: `${STATIC_URL}/courses/modern-methods-dmp/uniq_icon_4.svg` },
    title: 'Актуальность материала',
    text: 'Курс основан на самых актуальных данных и достижениях в области дистанционного медицинского наблюдения, позволяет изучить новые тенденции и применять их в своей работе',
  },
]

export {
  dataCardioUniq,
  dataOsteoporosisUniq,
  dataSomnologyUniq,
  dataGktUniq,
  dataGeriatryBasicUniq,
  dataMiniCardioUniq,
  dataModernMethodsDmpUniq,
}
export type { IData }
